import { transport } from 'config/transport';

export function callApiCreateClass(gradeId, body) {
    return transport.post(`/mamnon/grades/${gradeId}/classes`, body);
}
